import { RiskRating } from "@/types/sorin";
import { cn } from "@/lib/utils";

interface RiskRatingBadgeProps {
  rating: RiskRating;
  score: number;
  showScore?: boolean;
}

export const RiskRatingBadge = ({ rating, score, showScore = true }: RiskRatingBadgeProps) => {
  const config = {
    very_low: { 
      bg: "bg-success", 
      text: "text-success-foreground", 
      label: "VERY LOW", 
      icon: "✓" 
    },
    low: { 
      bg: "bg-success/80", 
      text: "text-success-foreground", 
      label: "LOW", 
      icon: "✓" 
    },
    medium: { 
      bg: "bg-warning", 
      text: "text-warning-foreground", 
      label: "MEDIUM", 
      icon: "⚠" 
    },
    high: { 
      bg: "bg-destructive/80", 
      text: "text-destructive-foreground", 
      label: "HIGH", 
      icon: "⚠" 
    },
    very_high: { 
      bg: "bg-destructive", 
      text: "text-destructive-foreground", 
      label: "VERY HIGH", 
      icon: "🔴" 
    },
  };
  
  const { bg, text, label, icon } = config[rating];
  
  return (
    <div className={cn(
      "inline-flex items-center justify-between gap-3 px-4 py-2 rounded-lg font-bold",
      bg, text
    )}>
      <span className="flex items-center gap-1.5">
        <span>{icon}</span>
        <span>{label}</span>
      </span>
      {showScore && <span className="text-2xl">{score}</span>}
    </div>
  );
};
